const BlockType = require('../../extension-support/block-type');
const ArgumentType = require('../../extension-support/argument-type');
const Cast = require('../../util/cast');
const Scratch3LooksBlocks = require('../../blocks/scratch3_looks');
const uid = require('../../util/uid');
const menuIconURI = "data:image/png;base64,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"

class PythonTextBlocks {
    constructor(runtime) {
        if (!runtime) {
            throw new Error('Runtime is required for PythonStatementsBlocks');
        }
        this.runtime = runtime;
    }

    getInfo() {
        return {
            id: "pythonText",
            color1: '#ffd700',
            name: "Python Text",
            menuIconURI: menuIconURI,
            blockIconURI: menuIconURI,
            blocks: [
                {
                    opcode: "format_print_message",
                    blockType: BlockType.REPORTER,
                    text: `f "[FIRST] {[SECOND]} [THIRD]"`,
                    arguments: {
                        FIRST: {
                            type: ArgumentType.STRING,
                            defaultValue: "Enter statement"
                        },
                        SECOND: {
                            type: ArgumentType.REPORTER,
                            defaultValue: "0"
                        },
                        THIRD: {
                            type: ArgumentType.STRING,
                            defaultValue: "Enter statement"
                        }
                    }
                },
                {
                    opcode: "python_length",
                    blockType: BlockType.REPORTER,
                    text: "length ([ITEM])",
                    arguments: {
                        ITEM: {
                            type: ArgumentType.STRING,
                            defaultValue: "example"
                        }
                    }
                },
                {
                    opcode: "change_case",
                    blockType: BlockType.REPORTER,
                    text: "[TEXT].[CASE]()",
                    arguments: {
                        TEXT: {
                            type: ArgumentType.STRING,
                            defaultValue: "Hello World"
                        },
                        CASE: {
                            type: ArgumentType.STRING,
                            menu: "caseTypes",
                            defaultValue: "upper"
                        }
                    }
                },
                {
                    opcode: "slice_text",
                    blockType: BlockType.REPORTER,
                    text: "[TEXT][START]:[END]:[STEP]",
                    arguments: {
                        TEXT: {
                            type: ArgumentType.STRING,
                            defaultValue: "Hello World"
                        },
                        START: {
                            type: ArgumentType.NUMBER,
                            defaultValue: ""
                        },
                        END: {
                            type: ArgumentType.NUMBER,
                            defaultValue: "5"
                        },
                        STEP: {
                            type: ArgumentType.NUMBER,
                            defaultValue: "1"
                        }
                    }
                },
                {
                    opcode: "index_text",
                    blockType: BlockType.REPORTER,
                    text: "[TEXT][INDEX]",
                    arguments: {
                        TEXT: {
                            type: ArgumentType.STRING,
                            defaultValue: "Hello World"
                        },
                        INDEX: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0
                        }
                    }
                },
                {
                    opcode: "reverse_text",
                    blockType: BlockType.REPORTER,
                    text: "[TEXT] ::-1",
                    arguments: {
                        TEXT: {
                            type: ArgumentType.STRING,
                            defaultValue: "Hello World"
                        }
                    }
                },
                {
                    opcode: "replace_text",
                    blockType: BlockType.REPORTER,
                    text: "[TEXT]. replace([TARGET], [REPLACEMENT])",
                    arguments: {
                        TEXT: {
                            type: ArgumentType.STRING,
                            defaultValue: "Hello World"
                        },
                        TARGET: {
                            type: ArgumentType.STRING,
                            defaultValue: "World"
                        },
                        REPLACEMENT: {
                            type: ArgumentType.STRING,
                            defaultValue: "Universe"
                        }
                    }
                }
            ],
            menus: {
                caseTypes: {
                    acceptReporters: false,
                    items: ["upper", "lower", "title"]
                }
            }
        };
    }

    format_print_message(args, util) {
        const first = Cast.toString(args.FIRST);
        const second = Cast.toString(args.SECOND);
        const third = Cast.toString(args.THIRD);
        
        // Combine the three parts with proper spacing
        return `${first} ${second} ${third}`;
    }

    python_length(args, util) {
        const item = args.ITEM;

        try {
            const parsedItem = JSON.parse(item);
            if (typeof parsedItem === 'string' || Array.isArray(parsedItem)) {
                return parsedItem.length;
            } else {
                return 'invalid datatype';
            }
        } catch (e) {
            if (typeof item === 'string') {
                return item.length;
            } else {
                return 'invalid datatype';
            }
        }
    }

    change_case(args, util) {
        const text = Cast.toString(args.TEXT);
        const caseType = args.CASE;

        switch (caseType) {
            case 'upper':
                return text.toUpperCase();
            case 'lower':
                return text.toLowerCase();
            case 'title':
                return text.split(' ')
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                    .join(' ');
            default:
                return text;
        }
    }

    slice_text(args, util) {
        const text = Cast.toString(args.TEXT);
        const textLength = text.length;
        let step = Cast.toString(args.STEP).length === 0 ? 1 : Cast.toNumber(args.STEP);
        
        // Handle step = 0 case
        if (step === 0) return 'Step cannot be 0';

        // Set default values based on step direction
        let start = Cast.toString(args.START).length === 0 ? 
            (step > 0 ? 0 : textLength - 1) : Cast.toNumber(args.START);
        let end = Cast.toString(args.END).length === 0 ? 
            (step > 0 ? textLength : -(textLength + 1)) : Cast.toNumber(args.END);

        // Handle negative indices
        if (start < 0) start = textLength + start;
        if (end < 0) end = textLength + end;

        try {
            // Convert text to array for easier slicing
            const chars = Array.from(text);
            const result = [];

            // Implement Python-style slicing
            if (step > 0) {
                for (let i = start; i < end; i += step) {
                    if (i >= 0 && i < chars.length) {
                        result.push(chars[i]);
                    }
                }
            } else {
                for (let i = start; i > end; i += step) {
                    if (i >= 0 && i < chars.length) {
                        result.push(chars[i]);
                    }
                }
            }

            return result.join('');
        } catch (e) {
            return 'Invalid slice parameters';
        }
    }

    index_text(args, util) {
        const text = Cast.toString(args.TEXT);
        let index = Cast.toNumber(args.INDEX);
        
        // Handle negative index
        if (index < 0) {
            index = text.length + index;
        }
        
        // Check if index is within bounds
        if (index < 0 || index >= text.length) {
            return 'Index out of range';
        }

        try {
            // Use Array.from to properly handle Unicode characters
            const chars = Array.from(text);
            return chars[index];
        } catch (e) {
            return 'Invalid index';
        }
    }

    reverse_text(args, util) {
        const text = Cast.toString(args.TEXT);
        
        try {
            // Use Array.from to properly handle Unicode characters
            const chars = Array.from(text);
            return chars.reverse().join('');
        } catch (e) {
            return 'Invalid text';
        }
    }

    replace_text(args, util) {
        const text = Cast.toString(args.TEXT);
        const target = Cast.toString(args.TARGET);
        const replacement = Cast.toString(args.REPLACEMENT);
        
        try {
            // Replace all occurrences of target with replacement
            return text.replaceAll(target, replacement);
        } catch (e) {
            return 'Invalid replacement parameters';
        }
    }
}

module.exports = PythonTextBlocks;